import { FIND_A_PRO_RESULTS_PAGENAME } from "@/components/FindAProResults/v1/utils"

export const isPageNameFindAProResults = pageType => {
  return FIND_A_PRO_RESULTS_PAGENAME.includes(pageType)
}
